import { CircleCheck, TriangleAlert } from "@tamagui/lucide-icons";
import { XStack, useTheme } from "tamagui";

import { Text } from "@/components/Typography";
import { brandName } from "@/config/brand";

interface ConversationClosedNoteProps {
  isCuraiConversation?: boolean;
}

const ConversationClosedNote = ({
  isCuraiConversation = false,
}: ConversationClosedNoteProps) => {
  const theme = useTheme();

  const Icon = isCuraiConversation ? TriangleAlert : CircleCheck;
  const text = isCuraiConversation
    ? `This visit has ended. Start a new one from ${brandName} to speak with another clinician about the same or a different topic.`
    : `Your chat with ${brandName} is complete`;

  return (
    <XStack
      alignItems="center"
      gap="$150"
      alignSelf="center"
      marginHorizontal="$200"
      marginVertical="$100"
    >
      <Icon
        color={theme.iconBase.get()}
        flexShrink={0}
        strokeWidth={1.5}
        size="$225"
        marginBottom="$50"
        marginTop="$25"
      />
      <Text conversational fontFamily="$sans-serif">
        {text}
      </Text>
    </XStack>
  );
};
export default ConversationClosedNote;
